import AllRoutes from "./Allroutes/AllRoutes";
// import Navbar from "./Allroutes/Navbar";
import logo from "./logo.svg";

function App() {
  return (
    <div className="App">
     <AllRoutes/>
    </div>
  );
}

export default App;
